import React from "react"
import { Navigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import Home from "./pages/Home.jsx"
import { setIsFromDashboardPayable } from "./state/outstandingPayableSlice.jsx";
import { setIsFromDashboardReceivable } from "./state/outstandingReceivableSlice.jsx";

function PrivateRoute({ children, page, authorized = false }) {

  const dispatch = useDispatch();
  const { menu, isAuthenticated } = useSelector((state) => state.auth)
  //reset dashboard tab selection set selected from outstanding tab dashboard 

  if (page.name != "Dashboard" && page.name != "OutRPartyDetail" && page.name != "OutRPartyDetail"
    && page.name != "OutPPartyAgeSummary" && page.name != "OutRPartyAgeSummary"
  ) {
    dispatch(setIsFromDashboardPayable(false))
    dispatch(setIsFromDashboardReceivable(false))
  }

  function isMenuExist() {
    const menuApp = menu.appMenu.filter(
      (menuItem) => menuItem.controller === page.name
    )
    const menuUser = menu.userMenu.filter(
      (menuItem) => menuItem.controller === page.name
    )

    if (menuApp.length > 0 && menuUser.length > 0) {
      return true
    } else {
      return false
    }
  }


  if (!isAuthenticated) {
    return <Navigate to={process.env.REACT_APP_ENDPOINT} replace={true} />
  } else if (!authorized & !isMenuExist()) {
    return <Home/>
  }
  return children
}
export default PrivateRoute
